import React, {} from "react";

const AppSidebarHeader = (props) =>
{
    return (
        <div className="dt-module__sidebar-header border-bottom">
            <div className="d-none d-md-flex align-items-center justify-content-center">
                <i className={ "icon " + props.iconName + " icon-2x mr-4"}/>
                <span className="h2 mb-0 text-muted">{props.title}</span>
            </div>
            { props.children }
        </div>
    )
}

export default AppSidebarHeader;
